export default function logout(store: any, redirect: any) {
  localStorage.removeItem('user')
  store.commit('auth/resetUser')
  redirect('/login')
}
